// import IconDownload from "components/Icons/IconDownload";
import IconEye from "components/Icons/IconEye";
import IconSuccess from "components/Icons/IconSuccess";
import { IPeriodicTime } from "core/enums/plans.enum";
import {
  EPaymentMethod,
  useLandingPageContext,
} from "pages/Context/LandinPageContext";
import React from "react";

export default function PaymentWithSuccess() {
  const { paymentMethodContext, selectedPlanContext, ticketPDF, isManualPaymentContext } =
    useLandingPageContext();
  const REACT_APP_WEB_APP_URL = process.env.REACT_APP_WEB_APP_URL ?? "";

  // Pagamento caiu no fluxo manual (gateway indisponível). Mostra confirmação
  // de cadastro + aviso de verificação, em vez de "pagamento confirmado".
  // Cobre os 3 métodos de pagamento de uma vez.
  if (isManualPaymentContext) {
    return (
      <div className="payment-success d-flex gap-3 flex-column align-items-center p-5">
        <div className="d-flex flex-column align-items-center">
          <IconSuccess width={120} />
          <h5 className="text-center fw-bold mt-3 mb-0">
            Cadastro concluído!
          </h5>
          <p className="text-muted text-center mt-1">
            Recebemos seu pagamento e nossa equipe está verificando a confirmação.
            Você receberá um e-mail assim que estiver tudo certo. Você já pode
            acessar a plataforma.
          </p>
        </div>
        <p className="text-muted text-center">
          Se tiver <strong>alguma dúvida</strong>, nossa equipe de suporte está à
          disposição pelo telefone <strong>(31) 9854-5248</strong> ou envie um
          e-mail para <strong>suporte@licitem.com</strong>. Teremos prazer em
          ajudar!
        </p>
        <p className="text-center mt-4">
          Acesse agora:{" "}
          <a
            href={REACT_APP_WEB_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="fw-bold"
          >
            {REACT_APP_WEB_APP_URL.replace(/^https?:\/\//, "").replace(/\/$/, "")}
          </a>
        </p>
      </div>
    );
  }

  return (
    <div>
      {EPaymentMethod.BOLETO === paymentMethodContext && ticketPDF && (
        <div className="payment-success d-flex gap-3 flex-column p-5">
          <div>
            <div className="d-flex justify-content-center">
              <IconSuccess width={120} />
            </div>
            <h5 className="text-center fw-bold mb-3">
              Boleto gerado com sucesso!
            </h5>
          </div>

          <div className="d-flex justify-content-center align-items-center mb-3">
            {/* Botão de Visualizar Boleto */}
            <a
              href={ticketPDF}
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex gap-1 align-items-center text-primary text-decoration-none"
            >
              <IconEye width={22} />
              <div className="fw-semibold">Clique para visualizar o boleto</div>
            </a>

            {/* <span className="mx-2">ou</span>

            <a
              onClick={handleDownload}
              download="boleto.pdf"
              className="d-flex gap-1 align-items-center text-primary text-decoration-none"
              style={{ cursor: "pointer" }}
            >
              <IconDownload width={20} className="mb-1" />
              <div className="fw-semibold">Baixar Boleto</div>
            </a> */}
          </div>

          <div className="text-muted text-center">
            <p>
              A confirmação do pagamento pode levar até{" "}
              <strong>48 horas úteis</strong>. Assim que for identificado, seu
              acesso será liberado automaticamente. Caso tenha dúvidas ou
              precise de suporte, entre em contato com nossa equipe.
            </p>
            <p>
              Você já pode acessar nossa plataforma e visualizar os processos do
              seu interesse. <strong>Acesse agora: </strong>
              <a
                href={REACT_APP_WEB_APP_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {REACT_APP_WEB_APP_URL.replace(/^https?:\/\//, "").replace(
                  /\/$/,
                  ""
                )}
              </a>
            </p>
          </div>
        </div>
      )}

      {EPaymentMethod.PIX === paymentMethodContext && (
        <>
          {selectedPlanContext?.period.type === IPeriodicTime.FREE ? (
            <div className="payment-success d-flex gap-3 flex-column align-items-center p-5">
              <div className="d-flex flex-column align-items-center">
                <IconSuccess width={120} />
                <h5 className="text-center fw-bold mt-3 mb-0">
                  Cadastramento realizado com sucesso!
                </h5>
                <p className="text-muted text-center mt-1">
                  Obrigado por cadastrar! Seu acesso à plataforma está liberado.
                </p>
              </div>
              <p className="text-muted text-center">
                Se tiver <strong>alguma dúvida</strong>, nossa equipe de suporte
                está à disposição pelo telefone <strong>(31) 9854-5248</strong>{" "}
                ou envie um e-mail para <strong>suporte@licitem.com</strong>.
                Teremos prazer em ajudar!
              </p>
              <p className="text-center mt-4">
                Acesse agora:{" "}
                <a
                  href={REACT_APP_WEB_APP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-bold"
                >
                  {REACT_APP_WEB_APP_URL.replace(/^https?:\/\//, "").replace(
                    /\/$/,
                    ""
                  )}
                </a>
              </p>
            </div>
          ) : (
            <div className="payment-success d-flex gap-3 flex-column align-items-center p-5">
              <div className="d-flex flex-column align-items-center">
                <IconSuccess width={120} />
                <h5 className="text-center fw-bold mt-3 mb-0">
                  Pagamento realizado com sucesso!
                </h5>
                <p className="text-muted text-center mt-1">
                  Obrigado por assinar! Seu pagamento via Pix foi confirmado e
                  seu acesso à plataforma está liberado.
                </p>
              </div>
              <p className="text-muted text-center">
                Se tiver <strong>alguma dúvida</strong>, nossa equipe de suporte
                está à disposição pelo telefone <strong>(31) 9854-5248</strong>{" "}
                ou envie um e-mail para <strong>suporte@licitem.com</strong>.
                Teremos prazer em ajudar!
              </p>
              <p className="text-center mt-4">
                Acesse agora:{" "}
                <a
                  href={REACT_APP_WEB_APP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-bold"
                >
                  {REACT_APP_WEB_APP_URL.replace(/^https?:\/\//, "").replace(
                    /\/$/,
                    ""
                  )}
                </a>
              </p>
            </div>
          )}
        </>
      )}

      {EPaymentMethod.CREDIT_CARD === paymentMethodContext && (
        <div className="payment-success d-flex gap-3 flex-column align-items-center p-5">
          <div className="d-flex flex-column align-items-center">
            <IconSuccess width={120} />
            <h5 className="text-center fw-bold mt-3 mb-0">
              Pagamento realizado com sucesso!
            </h5>
            <p className="text-muted text-center mt-1">
              Obrigado por assinar! Seu pagamento foi confirmado e seu acesso à
              plataforma está liberado.
            </p>
          </div>
          <p className="text-muted text-center">
            Se tiver <strong>alguma dúvida</strong>, nossa equipe de suporte
            está à disposição pelo telefone <strong>(31) 9854-5248</strong> ou
            envie um e-mail para <strong>suporte@licitem.com</strong>. Teremos
            prazer em ajudar!
          </p>
          <p className="text-center mt-4">
            Acesse agora:{" "}
            <a
              href={REACT_APP_WEB_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="fw-bold"
            >
              {REACT_APP_WEB_APP_URL.replace(/^https?:\/\//, "").replace(
                /\/$/,
                ""
              )}
            </a>
          </p>
        </div>
      )}
    </div>
  );
}
